import apiService from "./ApiService";

export class BookingService {
  async findAll() {
    return (await apiService.get("/api/booking", {})).data;
  }

  async save(data) {
   const response= await apiService.post("/api/billing", data);
   return response.data
  }

  async clearPendingDues(data) {
    const response= await apiService.post("/api/billing/clearPendingDues", data);
    return response.data
   }

  async findOne(id: string) {
    return (await apiService.get(`/api/booking/${id}`)).data;
  }

  async update(id: string, body) {
    await apiService.put(`/api/booking/${id}`, body);
  }

  async delete(id: string): Promise<void> {
    await apiService.put(`/api/booking/delete/${id}`);
  }

  async filteredData(data) {
    const response = await apiService.post("/api/booking/filteredData", data);
    return response.data;
  }

  async updateBooking(id: string, body) {
    await apiService.put(`/api/booking/bookingUpdate/${id}`, body);
  }

  async emailSent(data) {
    await apiService.post("/api/billing/send-mail", data);
  }

  async findAllDeals(){
    return (await apiService.get(`/api/packages`)).data;
  }

  async discountServicesSave(data){
    await apiService.post("/api/discount-service", data);
  }

    async discountServicesUpdate(id: string, body) {
    await apiService.patch(`/api/discount-service/${id}`, body);
  }
}
const bookingService = new BookingService();
export { bookingService as default };
